export default __webpack_public_path__ + "static/media/clock.98c536db.svg";